module.exports = __webpack_public_path__ + "static/media/lyn-lose.2613b852.png";